<template>
  <div class="board-body">
    <div class="no-data">
      <!-- If no databases available -->
      <div dz-preview-wrapper class="dz-no-content-message">
        <h3>Keine Datenbanken vorhanden</h3>
        <img src="../assets/img/nodata.svg" class="no-data default-cursor" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoDatabases',
};
</script>

<style scoped>
.board-body {
  width: 100%;

  /* i dont know why but height 100% doesnt work only min-height */
  min-height: 100%;
  height: fit-content;
  text-align: center;
  color: #5f697a;
  display: block;
  border-top: 1px solid rgb(231, 231, 232);
  background-color: #f9f9fb;
  display: flex;
  justify-content: center;
  background-color: #fff;
}

.no-data {
  display: block;
  position: absolute;
  height: fit-content;
  margin-top: 150px;
}

.dz-no-content-message img.no-data.default-cursor {
  cursor: default;
}

.dz-no-content-message {
  width: 100%;
  text-align: center;
  color: #6b7482;
  font-weight: 300;
  margin: auto;
}

.dz-no-content-message img.no-data {
  position: inherit;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  width: 278px;
  cursor: pointer;
}

.dz-no-content-message h3 {
  font-size: 23px;
  font-weight: 300;
}
</style>
